import { ApiConfig, HttpMethod, DynamicUrl, MICRO_SERVER_URL_SCM, MICRO_SERVER_URL_CASE, SseConfig } from '../constant';

const URL_CASES = `${MICRO_SERVER_URL_SCM}/core/cases`;
const URL_MERGE_CASES = `${MICRO_SERVER_URL_SCM}/core/merge-cases/cases`;
const URL_VIEWS = `${MICRO_SERVER_URL_CASE}/meta/views`;
const URL_CASE_EVENTS = `${MICRO_SERVER_URL_SCM}/core/case-events`;
const URL_EVENTS_POOL = `${MICRO_SERVER_URL_SCM}/core/events-pool`;
const URL_NOTES = `${MICRO_SERVER_URL_SCM}/core/notes`;

/* case */
export const caseStatus: ApiConfig = {
  url: `${URL_CASES}/status`,
};

export const caseCreate: ApiConfig = {
  url: URL_CASES,
  method: HttpMethod.POST,
};

export const caseUpdate: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_CASES}/${String(id)}`,
  method: HttpMethod.PATCH,
};

export const caseUpdateInRealTime: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_CASES}/real-time/${String(id)}`,
  method: HttpMethod.PATCH,
  cancelPrev: false,
};

export const caseBatchUpdate: ApiConfig = {
  url: `${URL_CASES}/batches`,
  method: HttpMethod.PATCH,
};

export const caseDelete: ApiConfig = {
  url: URL_CASES,
  method: HttpMethod.DELETE,
};

export const caseTrashDelete: ApiConfig = {
  url: `${URL_CASES}/empty-trash`,
  method: HttpMethod.DELETE,
};

export const caseRelateInteraction: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_CASES}/relate-interaction/${String(id)}`,
};

export const caseProperties: ApiConfig<DynamicUrl> = {
  url: (number: string | number) => `${URL_CASES}/${String(number)}/case-number/properties`,
};

export const caseRelated: ApiConfig<DynamicUrl> = {
  url: (number: string | number) => `${URL_CASES}/${String(number)}/case-number/relations`,
};

export const caseNeighbors: ApiConfig<DynamicUrl> = {
  url: (number: string | number) => `${URL_VIEWS}/${number}/case-neighbors`,
  method: HttpMethod.POST,
};

export const caseResolveInteraction: ApiConfig = {
  url: `${URL_CASES}/resolve-interaction`,
  method: HttpMethod.POST,
};

export const caseResolveBulkCheck: ApiConfig = {
  url: `${URL_CASES}/resolve/bulk/check`,
};

export const caseResolveBulk: ApiConfig = {
  url: `${URL_CASES}/resolve/bulk`,
  method: HttpMethod.PATCH,
};

export const caseResolveBulkProgress: ApiConfig<DynamicUrl> = {
  url: (batch_no: string | number) => `${URL_CASES}/resolve/bulk/progress/${batch_no}`,
  method: HttpMethod.GET,
};

export const caseWatchedWithUuid: ApiConfig<DynamicUrl> = {
  url: (url: string | number) => `/ci/case/watch/${url}`,
  method: HttpMethod.GET,
  ignoreError: true,
};

/* merge case */
export const mergeCasesUpdate: ApiConfig = {
  url: URL_MERGE_CASES,
  method: HttpMethod.PATCH,
};

export const mergeCasesWithPage: ApiConfig = {
  url: URL_MERGE_CASES,
};

/* case views */
export const views: ApiConfig = {
  url: URL_VIEWS,
  cancelPrev: false,
};

export const viewsCreate: ApiConfig = {
  url: URL_VIEWS,
  method: HttpMethod.POST,
};

export const viewsDelete: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_VIEWS}/${String(id)}`,
  method: HttpMethod.DELETE,
};

export const viewsUpdate: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_VIEWS}/${String(id)}`,
  method: HttpMethod.PATCH,
};

export const viewsCasesWithPage: ApiConfig<DynamicUrl> = {
  url: (viewId: string | number) => `${URL_VIEWS}/${String(viewId)}/cases`,
  method: HttpMethod.POST,
};

export const caseCount: SseConfig = {
  url: `/ci/case/count`,
};

/* case events */
export const caseEventsUpdate: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_CASE_EVENTS}/${String(id)}`,
  method: HttpMethod.PATCH,
};

export const caseEventsPool: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_EVENTS_POOL}/${String(id)}/events`,
};

/* case notes */
export const notesCreate: ApiConfig = {
  url: URL_NOTES,
  method: HttpMethod.POST,
};

export const notesUpdate: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_NOTES}/${String(id)}`,
  method: HttpMethod.PATCH,
};

export const notesDelete: ApiConfig<DynamicUrl> = {
  url: (id: string | number) => `${URL_NOTES}/${String(id)}`,
  method: HttpMethod.DELETE,
};
